import customAxios from "./axios";
import CONFIG from "../../config";

export const paymentRefundRequestCreate = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/PaymentRefunds/Create", payload)
    .then((res) => {
      return res;
    });
};
